<template>
  <LayoutFeed
    v-bind="{ getFirstPage, getNextPage }"
    :groq-params="groqParams"
    @load-more="onLoadMore"
  >
    <template #header>
      <LayoutFeedHeader>Brands</LayoutFeedHeader>
    </template>
    <template #items="{ items, itemClass }">
      <BrandsFeedItem
        v-for="item in items"
        :key="`brand.${item._id}`"
        :brand="item"
        :class="itemClass"
      />
    </template>
    <template #not-found>
      <slot name="not-found" />
    </template>
  </LayoutFeed>
</template>

<script setup lang="ts">
import type * as Schema from "~/@types/schema"

const props = withDefaults(
  defineProps<{
    getFirstPage: () => string
    getNextPage: () => string
    groqParams?: Record<string, unknown>
  }>(),
  {
    groqParams: () => ({}),
  },
)

const { groqParams } = toRefs(props)

const onLoadMore = (item: Schema.Brands) => {
  const { name } = item

  groqParams.value.lastName = name
}
</script>
